import { useContext } from "react";
import IOAbstract, { EditContext, type IOProps } from "./io-abstract";

export default function IOBoolean(
  props: IOProps<boolean> & {
    trueValue?: string;
  }
) {
  const editContext = useContext(EditContext);

  return (
    <IOAbstract<boolean>
      editContext={editContext}
      inputType="checkbox"
      required={true}
      type="boolean"
      renderOutput={
        (props.value && <div data-export="1">✔</div>) || (
          <div data-export="0">✘</div>
        )
      }
      renderInput={(uuid) => (
        <>
          <input
            id={uuid}
            className="form-check-input"
            defaultChecked={props.value}
            name={props.name}
            type="checkbox"
            value={props.trueValue ?? "true"}
            onChange={(evt) => props.onChange?.(evt.target.checked)}
            {...props.htmlProps}
          />
          yes ?
        </>
      )}
      {...props}
    />
  );
}

// TODO: Check prefs for Financial Report
